<template>
  <div>
    <icon 
      name="loader" 
      v-for="(spinner, index) in spinnerList" 
      :style="spinnerStyle(spinner.element)"
      :key="index"
    />
  </div>
</template>
<script>
import CommonService from '@/services/CommonService';
export default {
	name: "SpinnerList",
  data() {
    return {
      interval: null,
      reactivator: 0
    }
  },
  computed: {
    spinnerList() {
      const reactivator = this.reactivator
      return this.$store.state.toggle.spinnerList;
    }
  },
  methods: {
    spinnerStyle(element) {
      return CommonService.getSpinnerStyle(element);
    }
  },
  mounted() {
    const _this = this
    this.interval = setInterval(() => {
      const now = Math.floor(Date.now() / 1000)
      let flag = false
      _this.$store.state.toggle.spinnerList.forEach((spinner, index) => {
        const diff = now - spinner.timer
        if(diff > 20) {
          _this.$store.dispatch('endLoading', spinner.id);
          flag = true
        }
        if(!spinner.element || !CommonService.isVisible(spinner.element, 1)) {
          _this.$store.dispatch('endLoading', spinner.id);
          flag = true
        }
      })
      if(flag) {
        _this.reactivator ++
      }
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  
}
</script>
